var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.652833 0.87885L3.76746 3.99348L0.652833 7.10811C0.554969 7.20609 0.5 7.33892 0.5 7.47741C0.5 7.61589 0.554969 7.74872 0.652833 7.8467C0.701081 7.89556 0.758601 7.93428 0.822017 7.9606C0.885433 7.98693 0.953468 8.00032 1.02213 7.99999C1.09079 8.00032 1.15883 7.98693 1.22224 7.9606C1.28566 7.93428 1.34318 7.89556 1.39142 7.8467L4.87535 4.36278C4.97321 4.26479 5.02818 4.13197 5.02818 3.99348C5.02818 3.85499 4.97321 3.72217 4.87535 3.62418L1.39142 0.140257C1.29236 0.0479469 1.16133 -0.00230731 1.02595 8.14175e-05C0.89056 0.00247015 0.761386 0.0573153 0.665639 0.153063C0.569891 0.24881 0.515046 0.377984 0.512657 0.51337C0.510268 0.648756 0.560523 0.779784 0.652833 0.87885Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandFolderIcon);
export default __webpack_public_path__ + "static/media/expand-folder_icon.a560689dc97c723dcf6394107120d582.svg";
export { ForwardRef as ReactComponent };